/** SexVR's channels (13, from its home page on 2026-10-26). A channel page is /channels/<id>/<slug>/ and pages as ?page=N. Kept apart from the
 * source file so the strip (a client component) does not pull the scraper's server code into the browser. */
export const SEXVR_CHANNELS = [
  { id: 2, slug: "anal", label: "Anal" },
  { id: 8, slug: "big-tits", label: "Big Tits" },
  { id: 19, slug: "blonde", label: "Blonde" },
  { id: 18, slug: "brunette", label: "Brunette" },
  { id: 3, slug: "lesbian", label: "Lesbian" },
  { id: 14, slug: "masturbation", label: "Masturbation" },
  { id: 4, slug: "teen", label: "Teen" },
  { id: 1, slug: "threesome", label: "Threesome" },
  { id: 21, slug: "natural-tits", label: "Natural Tits" },
  { id: 51, slug: "couples", label: "Couples" },
  { id: 54, slug: "shaved-pussy", label: "Shaved Pussy" },
  { id: 48, slug: "medium-ass", label: "Medium Ass" },
  { id: 22, slug: "small-tits", label: "Small Tits" },
] as const
